module.exports = __webpack_public_path__ + "media/images/address/google-d3f69c66fcf2f21c44b8de82cfaaa3dc.svg";